import { UsersService } from '@/services/users.service'

export default {
  GET ({ commit }) {
    return UsersService.getCurrent()
      .then(user => commit('SET_USER', user))
      .catch(error => commit('toast/NEW', { type: 'error', message: error.message }, { root: true }))
  },

  CLEAR ({ commit }) {
    commit('SET_USER', {
      id: '',
      name: '',
      username: '',
      avatar:''
    });
  }
}
